import React, { ReactNode } from 'react';

import { MenuItemType } from 'antd/lib/menu/interface';
import styled from 'styled-components';

import Dropdown from '../../lib/Dropdown';

const Container = styled.div`
  margin-left: 213px;
`;

const AddFeeButton = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  line-height: 1;
  justify-content: center;
  width: 120px;
  height: 28px;
  border: 1px solid var(--line-gray);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  border-radius: 15px;
  font-size: 12px;
  &:hover {
    border: 1px solid var(--button-blue);
  }
`;

interface Props {
  label: string;
  options: MenuItemType[];
  content: ReactNode;
}

const ShopDataModalAddEntry = ({ label, options, content }: Props) => {
  return (
    <Container>
      <Dropdown
        menu={{
          items: options,
        }}
      >
        <AddFeeButton>{content}</AddFeeButton>
      </Dropdown>
    </Container>
  );
};

export default ShopDataModalAddEntry;
